import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const NewArrivals = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products")
      .then((r) => setProducts((r.data || []).slice(0, 24)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="new-arrivals-page" className="grain">
      {/* Header ribbon */}
      <section
        className="px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-10 border-b"
        style={{
          borderColor: "var(--rs-border)",
          background:
            "linear-gradient(180deg, rgba(20,10,15,0.55) 0%, rgba(10,10,10,0) 100%)",
        }}
      >
        <Link
          data-testid="new-arrivals-back-link"
          to="/"
          className="inline-flex items-center gap-2.5 text-xs uppercase tracking-[0.28em] text-bone hover:opacity-90 transition mb-10 px-5 py-3 border"
          style={{
            borderColor: "var(--rs-terracotta, #c07050)",
            background: "rgba(192,112,80,0.08)",
          }}
        >
          <ArrowLeft strokeWidth={1.75} size={14} />
          <Home strokeWidth={1.75} size={14} />
          Return to the Villa
        </Link>

        <div className="max-w-5xl">
          <div className="overline mb-5">Newly Arrived</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-bone leading-[1.05]">
            Tonight&apos;s{" "}
            <em className="not-italic" style={{ color: "var(--rs-terracotta)" }}>
              recommendations.
            </em>
          </h1>
          <p className="text-muted-bone mt-6 max-w-2xl text-base sm:text-lg leading-relaxed">
            The freshest additions to the house — hand-selected, quietly composed,
            still unwrapped. Slip in early; the well-loved pieces move quickly.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="px-6 md:px-12 lg:px-16 py-16 md:py-24">
        {loading ? (
          <div
            data-testid="new-arrivals-loading"
            className="text-muted-bone text-sm tracking-[0.22em] uppercase"
          >
            Composing tonight&apos;s selection…
          </div>
        ) : products.length === 0 ? (
          <div className="text-muted-bone italic">No arrivals just yet — check back after dark.</div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((p) => (
              <ProductCard key={p.product_id} product={p} />
            ))}
          </div>
        )}

        <div className="mt-16 flex flex-col sm:flex-row justify-center gap-4">
          <Link
            data-testid="new-arrivals-shop-all"
            to="/shop"
            className="px-10 py-4 uppercase text-xs tracking-[0.28em] text-bone border hover:bg-white/5 transition text-center"
            style={{ borderColor: "rgba(245,242,235,0.25)" }}
          >
            Browse the full villa →
          </Link>
          <Link
            data-testid="new-arrivals-back-link-bottom"
            to="/"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 uppercase text-xs tracking-[0.28em] text-bone hover:opacity-90 transition text-center"
            style={{ background: "var(--rs-oxblood)" }}
          >
            <Home strokeWidth={1.75} size={14} />
            Return to the Villa
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NewArrivals;
